import React from "react";

import { View } from "react-native";
import WelcomeCard from "./WelcomeCard";
import KnowledgeBaseCard from "./KnowledgeBaseCard";
import SurveyCard from "./SurveyCard";
import ImpersonateCard from "../cards/ImpersonateCard";
import TutorialsCard from "../cards/TutorialsCard";

export default function GatedProduct({ controller }) {
  const { has_scheduled_call } = controller.state.settings;

  const hasImpersonate =
    controller.state.impersonate != null &&
    controller.state.impersonate != controller.state.currentUser;

  return (
    <View>
      {has_scheduled_call ? (
        <KnowledgeBaseCard controller={controller} />
      ) : (
        <WelcomeCard controller={controller} />
      )}

      {/* <TutorialsCard controller={controller} key={"tutorialsCard"} /> */}

      <SurveyCard controller={controller} />

      {hasImpersonate ? (
        <ImpersonateCard
          controller={controller}
          data={{ user: controller.state.impersonate }}
        />
      ) : null}
    </View>
  );
}
